// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__MoreButton__hideMoreButton{visibility:hidden}", "",{"version":3,"sources":["webpack://./../../../src/internal/ApplicationHeader/MoreButton.module.scss","webpack://./../../platform/@jutro/router/internal/ApplicationHeader/MoreButton.module.css"],"names":[],"mappings":"AAAA,iCACE,iBCCF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hideMoreButton": "jut__MoreButton__hideMoreButton"
};
export default ___CSS_LOADER_EXPORT___;
